import { useEffect, useState } from 'react';
import { hasKnownEntityId } from '../utils/entityIdentity';
import FollowOutline from './FollowOutline';
import useFollowedEntities from './useFollowedEntities';
import { getAnonymousDisplay, isUnknownSpeakerId } from './speakerHelper';

const ProfilePicture = (
    {
        speakerId,
        anonymousDisplay,
        color,
        followed: positivePreference = false,
        imageLabel = 'Speaker portrait',
        imageSrc,
        margin,
        profileClick,
        size = '50px',
    }) => {

    const followed = positivePreference && hasKnownEntityId(speakerId);
    const anonymous = isUnknownSpeakerId(speakerId)
        ? getAnonymousDisplay(anonymousDisplay) : null;

    const [imageLoadFailed, setImageLoadFailed] = useState(false);

    useEffect(() => {
        setImageLoadFailed(false);
    }, [imageSrc]);

    const renderContent = () => {
        if (anonymous) {
            return (
                <FollowOutline circular style={{ margin }}>
                    <div
                        role='img'
                        aria-label='Unidentified speaker'
                        className='anonymousSpeakerAvatar'
                        data-anonymous-kind={anonymous.kind}
                        style={{ width: size, height: size, borderRadius: '50%',
                            backgroundColor: anonymous.avatar.background, color: anonymous.avatar.foreground,
                            display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <svg viewBox='0 0 24 24' width='64%' height='64%' aria-hidden='true' focusable='false'>
                            <circle cx='12' cy='8' r='4' fill='currentColor' />
                            <path d='M4 22v-2a8 8 0 0 1 16 0v2Z' fill='currentColor' />
                        </svg>
                    </div>
                </FollowOutline>
            );
        }
        const hasImage = !!imageSrc && !imageLoadFailed;
        return (
            <FollowOutline followed={followed} circular style={{ margin }}>
                <span className="profilePictureImage" style={{ width: size, height: size,
                    display: 'block', borderRadius: '50%', overflow: 'hidden', background: color || 'var(--app-surface-tertiary)' }}>
                    {hasImage && <img loading="lazy" alt={`${imageLabel}${followed ? ', followed' : ''}`}
                        src={imageSrc} onError={() => setImageLoadFailed(true)}
                        style={{ width: '100%', height: '100%', display: 'block', objectFit: 'cover' }} />}
                </span>
            </FollowOutline>
        );
    }

    const content = renderContent();

    if (profileClick && !anonymous) {
        return (
            <button 
                type="button"
                aria-label={`${imageLabel}${followed ? ", followed" : ""}`}
                onClick={profileClick}
                style={{
                    padding: 0,
                    border: 'none',
                    background: 'none',
                    cursor: 'pointer',
                    display: 'inline-block',
                    verticalAlign: 'middle'
                }}
            >
                {content}
            </button>
        );
    }

    return (
        <div style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            {content}
        </div>
    );
};

export { ProfilePicture };
const FollowedProfilePicture = (props) => {
    const isFollowed = useFollowedEntities();
    return <ProfilePicture {...props} followed={props.followed ?? isFollowed('speaker', { id: props.speakerId })} />;
};
export default FollowedProfilePicture;
